import MatchMedia from '../utils/matchMedia';
import { eaCollectorWrapper, dataLayerGAWrapper } from '../utils/taggingPlan';
import { getAttributeValue, checkAttributeValues } from '../utils/dom';

export default class ToggleMenuDesktop {
    constructor() {
        this.matchMedia = new MatchMedia();
        this.ui = this.getUI();
        this.listen();
    }

    getUI() {
        return {
            myToggleMenuDesktop: document.querySelectorAll(".js-toggle-menu-desktop"),
            mytoggleOut: document.querySelectorAll(".js-desktop-sub-menu-out"),
            body: document.querySelector("body"),
            html: document.querySelector("html")
        }
    }

    listen() {

        if(this.ui.myToggleMenuDesktop.length > 0) {
            this.ui.myToggleMenuDesktop.forEach((item) => {
                const toggleBtn = item.querySelector(".js-toggle-menu-desktop__btn");
                if(toggleBtn.attributes["aria-expanded"] === undefined) {
                    toggleBtn.setAttribute('aria-expanded', 'false');
                }
                toggleBtn.addEventListener("click", () => {
                    this.toggleCollapsedItem(item);
                });
                item.querySelector(".btn-close").addEventListener("click", () => { // Au click sur le bouton close du sous-menu ouvert
                    const toggleToClose = document.querySelector(".js-toggle-menu-desktop__btn[aria-expanded='true']");
                    toggleToClose.focus();
                    toggleToClose.click();
                });
                item.querySelector(".desktop-navigation__btn").addEventListener("keyup", e => { // Fermeture du sous-menu lors de ECHAP
                    const toggleOpen = document.querySelector(".js-toggle-menu-desktop__btn[aria-expanded='true']");
                    if (e.key === "Escape") {
                        if(toggleOpen !== null) {
                            toggleOpen.click();
                        }
                    }
                });
                item.querySelector(".desktop-navigation__btn").addEventListener("focus", e => { // Fermeture du sous-menu lors du passage d'un sous-menu à un bouton au clavier
                    // Vérification sécurisée des attributs data-whatinput et data-whatintent
                    const isKeyboardInput = checkAttributeValues(this.ui.html, [
                        { name: 'data-whatinput', expected: 'keyboard' },
                        { name: 'data-whatintent', expected: 'keyboard' }
                    ]);
                    
                    if(isKeyboardInput) {
                        const ariaExpanded = getAttributeValue(e.target, 'aria-expanded') || 'false';
                        const toggleOpen = document.querySelector(".js-toggle-menu-desktop__btn[aria-expanded='true']");
                        if(ariaExpanded === "false" && toggleOpen) {
                            toggleOpen.click();
                        }
                    }
                });
            });
            this.ui.mytoggleOut.forEach((item) => { // Fermeture du sous-menu ouvert lors d'un focus sur un lien sans sous-menu
                item.addEventListener("keyup", () => {
                    const toggleOpen = document.querySelector(".js-toggle-menu-desktop__btn[aria-expanded='true']");
                    if(toggleOpen !== null) {
                        toggleOpen.click();
                    }
                });
            });
            this.ui.body.addEventListener("click", e => { // Au click en dehors du menu desktop
                const toggleOpen = document.querySelector(".js-toggle-menu-desktop__btn[aria-expanded='true']");
                if(e.target.closest('.desktop .header-bottom') === null) {
                    if(toggleOpen !== null) {
                        toggleOpen.click();
                    }
                }
            });
        }
    }

    toggleCollapsedItem(item) { // Gestion des évènements ouverture et fermeture du / des toggle(s)
        const description = item.querySelector('.toggle-menu-desktop__text');
        const button = item.querySelector('.js-toggle-menu-desktop__btn');

        if (description.classList.contains('d-none')) { // Si le toggle est fermé
            const toggleOpen = document.querySelector(".js-toggle-menu-desktop__btn[aria-expanded='true']");
            if(toggleOpen !== null) { // Si un des toggles est ouvert
                toggleOpen.click();
            }
            description.classList.remove('d-none');
            description.style.display = 'block';
            description.style.height = (description.scrollHeight / 16) + 'rem';
            button.setAttribute('aria-expanded', 'true');
            setTimeout(() => {
                description.style.height = 'auto'; // Cela permet de garder visible tout le contenu du toggle lors d'un resize ou d'un zoom text only
            }, 300);
        } else { // Si le toggle est ouvert
            description.style.height = (description.scrollHeight / 16) + 'rem';
            setTimeout(() => {
                description.classList.add('d-none');
                description.style.height = '0';
            }, 1);
            setTimeout(() => {
                description.style.display = 'none';
                button.setAttribute('aria-expanded', 'false');
            }, 300);
        }
    }
}